import { IntlType } from '../../../../utils/typing';

interface Props {
  intl: IntlType;
  handleClick: () => void;
}

const CancelButton = (props: Props): JSX.Element => {
  const { intl, handleClick } = props;

  return (
    <button className="cancel-button" onClick={handleClick}>
      {intl.formatMessage({ id: 'cancel' })}
    </button>
  );
};

export default CancelButton;
